/**
 * How a job's urgency is worded, in one place.
 *
 * The column stores High / Medium / Low, and it keeps storing those — but
 * "Medium" tells a recruiter nothing about what to do next. What they need to
 * know is how fast this one has to move, so that is what every screen shows.
 *
 * `label` is the word on its own — a badge in a list, a row in a summary.
 * `hint` is the commitment behind it, shown where someone is choosing rather
 * than reading. Nothing shows the raw stored value, and nothing invents its
 * own wording: change a label here and it changes everywhere.
 */

export const URGENCY_LEVELS = [
  { value: 'High', label: 'Urgent', hint: 'hire within 2 weeks', color: 'var(--red)' },
  { value: 'Medium', label: 'Standard', hint: 'hire within 1 month', color: 'var(--yellow)' },
  { value: 'Low', label: 'Flexible', hint: 'no fixed deadline', color: 'var(--green)' },
];

export const DEFAULT_URGENCY = 'Medium';

const byValue = (value) =>
  URGENCY_LEVELS.find((l) => l.value === value)
  || URGENCY_LEVELS.find((l) => l.value === DEFAULT_URGENCY);

/** What a reader sees: the word alone. */
export const urgencyLabel = (value) => byValue(value).label;

/** What a chooser sees: the word plus what it commits them to. */
export const urgencyOptionLabel = (value) => {
  const level = byValue(value);
  return `${level.label} — ${level.hint}`;
};

export const urgencyColor = (value) => byValue(value).color;
